// NOTE: bootstrap and variables must be imported before other imports
import 'bootstrap/dist/css/bootstrap.min.css';
import 'components/src/styles/variables.css';
import {Users} from 'components/src/other/Users';
import ReactDOM from 'react-dom/client'
import {Route} from "react-router-dom";
import {App} from './App'
import 'components/src/lang/i18n.js';
import {AppSidebar} from "./AppSidebar";
import 'components/src/fonts/Manrope-VariableFont_wght.ttf'

ReactDOM.createRoot(document.getElementById('root')!).render(
    <App Sidebar={AppSidebar}>
        <Route path={"users/*"} element={
            <Users/>
        } />
    </App>
)
